import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import { Controller } from 'react-hook-form';
import ReactSelect from 'react-select';
import { FormGroup, Label } from 'reactstrap';
import LabelText from './LableText';

const SelectCustom = (props) => {
  const { label = true, register, placeholder, errors, control, options, ...res } = props;
  const name = register.name;
  const labelText = LabelText(name);
  const placeholderText = !label || placeholder ? (placeholder ? placeholder : labelText) : placeholder ? placeholder : labelText;

  return (
    <FormGroup>
      {label && <Label for={name}>{labelText}</Label>}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <>
            <ReactSelect placeholder={placeholderText} name={name} {...res} options={options} {...register} onChange={(file) => field.onChange(file)} selected={field.value} />
            <ErrorMessage errors={errors} name={name} render={({ message }) => <span style={{ color: 'red' }}>{`${labelText} ${message}`}</span>} />
          </>
        )}
      />
    </FormGroup>
  );
};

export default SelectCustom;
